import { Box, CircularProgress, Stack, Text } from '@ltvco/refresh-lib/theme';
import React from 'react';

export interface LoadingStateProps {
  message?: string;
  subtitle?: string;
  size?: number;
}

export const LoadingState: React.FC<LoadingStateProps> = ({
  message = 'Searching court records...',
  subtitle = 'This may take a few moments',
  size = 40,
}) => (
  <Box sx={{ py: 4, textAlign: 'center' }}>
    <Stack alignItems="center" spacing={2}>
      <CircularProgress size={size} />
      <Text variant="h5" color="text.secondary">
        {message}
      </Text>
      {subtitle && (
        <Text variant="body2" color="text.secondary">
          {subtitle}
        </Text>
      )}
    </Stack>
  </Box>
);
